import { ConfigProvider } from 'antd';

ConfigProvider.config({
    theme: {
        primaryColor: '#7b67fb'
    },
});
